import { uuidv4 } from '@firebase/util'
import {
  faCheck,
  faEye,
  faSpinner,
  faTimes,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { format, parse } from 'date-fns'
import {
  ChartBar,
  Files,
  FloppyDisk,
  Info,
  Printer,
  ShieldCheck,
  UploadSimple,
} from 'phosphor-react'
import React, { useEffect, useState } from 'react'
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Form,
  Modal,
  Row,
  Spinner,
  Table,
} from 'react-bootstrap'
import {
  FileEarmarkArrowUp,
  FileEarmarkPdf,
  Search,
} from 'react-bootstrap-icons'
import { FaEdit, FaEye, FaFileAlt, FaSave, FaTrash } from 'react-icons/fa'
import {
  default as InputMask,
  default as ReactInputMask,
} from 'react-input-mask'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import { ContentLoading } from '../../components/ContentLoading/index.js'
import { CustomButton } from '../../components/CustomButton/index.jsx'
import Navbar from '../../components/navbar/navbar.jsx'
import apinode from '../../services/apinode'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage.js'

const EdicaoNFe = () => {
  const navigate = useNavigate()
  const [destinatarioValue, setDestinatarioValue] = useState('')
  const TYPING_TIMEOUT = 1000 // 500 milissegundos
  const [loading, setLoading] = useState(true)
  const [isGravarNfeLoading, setIsGravarNfeLoading] = useState(false)
  const { idnfe } = useParams()
  const [numeroNFe, setNumeroNFe] = useState('')
  const [serie, setSerie] = useState('')
  const [destinatario, setDestinatario] = useState('')
  const [itens, setItens] = useState([])
  const [totais, setTotais] = useState({})
  const [impostos, setImpostos] = useState({})
  const [natureza, setNatureza] = useState('')
  const [inputValue, setInputValue] = useState('')
  const [datavenda, setDataVenda] = useState('')
  const [cep, setCep] = useState('')
  const [logradouro, setLogradouro] = useState('')
  const [pesNum, setPesNum] = useState('')
  const [pesBairro, setPEsBairro] = useState('')
  const [pesCidade, setPesCidade] = useState('')
  const [codIbge, setIbge] = useState('')
  const [uf, setUf] = useState('')
  const [showAddressModal, setShowAddressModal] = useState(false)
  const [nfeItens, setNfeItens] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [editedItem, setEditedItem] = useState(null)
  const [total, setTotal] = useState(0)
  const [totalLiquido, setTotalLiquido] = useState(0)
  const [searchResults, setSearchResults] = useState([])
  const [id_cliente, setIdCliente] = useState([])
  const [totalnfe, setTotalnfe] = useState(0)
  const [frete, setFrete] = useState(0)
  const [idtransp, setIdTransp] = useState(null)
  const [cnpjTransp, setCnpjTransp] = useState('')
  const [nomeTransp, setNomeTransp] = useState('')
  const [pesol, setPesol] = useState('')
  const [volume, setVolume] = useState('')
  const [pesob, setPesob] = useState('')
  const [typingTimeout, setTypingTimeout] = useState(null)
  const [emp_conta, setEmpConta] = useState('')
  const [searchResultsProd, setSearchResultsProd] = useState([])
  const [showModalTrans, setShowModalTrans] = useState(false)
  const [transmitting, setTransmitting] = useState(false)
  const [responseMessage, setResponseMessage] = useState('')
  const [tipo, setTipo] = useState('S')
  const [erro, setErro] = useState('')
  const [status, setStatus] = useState('')
  const [searchResultsTrans, setSearchResultsTrans] = useState([])
  const [observacaoInterna, setObservacaoInterna] = useState('')
  const [parcelas, setParcelas] = useState([])
  const [diasParcelas, setDiasParcelas] = useState('')
  const [resultado, setResultado] = useState([])
  const [tipoFrete, setTipoFrete] = useState('')
  const [chave, setChave] = useState('')
  const [linknfe, setLink] = useState('')
  const [reload, setReload] = useState(false) // State to trigger re-fetch
  const [isConsultarLoading, setIsConsultarLoading] = useState(false)
  const [isEnviarDadosLoading, setIsEnviarDadosLoading] = useState(false)
  const [statusConsultar, setStatusConsultar] = useState()

  const handleExcluirParcela = (numeroParcela) => {
    const novasParcelas = parcelas.filter(
      (parcela) => parcela.codigo !== numeroParcela,
    )
    setParcelas(novasParcelas)
  }

  const handeleditarValor = (numParcela, novoValor) => {
    // Encontre a parcela pelo número da parcela
    const parcelaEditada = parcelas.map((parcela) =>
      parcela.num_parcela === numParcela
        ? { ...parcela, valor: novoValor }
        : parcela,
    )

    // Atualize o estado das parcelas com a parcela editada
    setParcelas(parcelaEditada)
  }

  const calcularParcelas = () => {
    const vl_total = totalnfe
    if (isNaN(parseFloat(vl_total))) {
      console.error('O valor total da compra não é válido.')
      return
    }

    const total = parseFloat(vl_total)
    const diasArray = diasParcelas
      .split(',')
      .map((dias) => parseInt(dias.trim()))

    if (diasArray.some(isNaN) || diasArray.some((dias) => dias <= 0)) {
      console.error('A entrada de dias de vencimento não é válida.')
      return
    }

    const dt_pedido_obj = new Date(datavenda)
    if (isNaN(dt_pedido_obj.getTime())) {
      console.error('A data do pedido não é válida.')
      return
    }

    const parcelas = diasArray.map((dias, index) => {
      const datavencimento = new Date(dt_pedido_obj)
      datavencimento.setDate(datavencimento.getDate() + dias)

      const valorParcela = total / diasArray.length

      return {
        num_parcela: index + 1,
        data: `${datavencimento}`,
        valor: valorParcela.toFixed(2),
        obs: '', // Adicione um campo para a observação
      }
    })

    setParcelas(parcelas)
  }
  const handleEditarObservacao = (numeroParcela, novaObservacao) => {
    const novasParcelas = parcelas.map((parcela) =>
      parcela.numero === numeroParcela
        ? { ...parcela, obs: novaObservacao }
        : parcela,
    )
    setResultado(novasParcelas)
  }

  async function handleGravarNFe() {
    const dadosNfe = {
      codcliente: id_cliente,
      itens: nfeItens,
      natureza: natureza,
      datavenda: datavenda,
      volume: volume,
      pesob: pesob,
      pesol: pesol,
      idtransportadora: idtransp,
      totalpedido: totalnfe,
      emp_conta: emp_conta,
      tipo: tipo,
      complemento: observacaoInterna,
      parcelas: parcelas,
      frete: tipoFrete,
      valorfrete: frete,
    }

    try {
      setIsGravarNfeLoading(true)

      if (idnfe === 'novo') {
        const response = await apinode.post(
          `/nfe/inserir/${localStorage.idconta}`,
          dadosNfe,
        )

        toast.success('Cadastro realizado com sucesso!')
        navigate(`/nfe/editar/${response.data.idnfe}`)
      } else {
        await apinode.put(`nfe/${idnfe}/${localStorage.idconta}`, dadosNfe)

        await fetchNfe()

        toast.success('Alterações realizadas com sucesso!')
      }
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao gravar nota fiscal')
    } finally {
      setIsGravarNfeLoading(false)
    }
  }

  const getStatusLabel = (status) => {
    let colorClass = ''
    let text = ''
    switch (status) {
      case 'T':
        colorClass = 'bg-success'
        text = 'Transmitida'
        break
      case 'R':
        colorClass = 'bg-danger'
        text = 'Erro'
        break
      case 'D':
        colorClass = 'bg-info'
        text = 'Em Digitação'
        break
      case 'C':
        colorClass = 'bg-warning'
        text = 'Cancelada'
        break
      default:
        colorClass = 'bg-secondary'
        text = 'Desconhecido'
        break
    }
    return <span className={`badge ${colorClass}`}>{text}</span>
  }

  const handleSearchDestinatario = async (inputValue) => {
    try {
      const response = await apinode.get(
        `/nfe/listapessoa/${localStorage.idconta}`,
        {
          params: {
            dados: inputValue,
          },
        },
      )

      setSearchResults(response.data)
    } catch (error) {
      console.error(error)
    }
  }

  const handleInputChangeDestinatario = (e) => {
    const inputValue = e.target.value
    setDestinatarioValue(inputValue)
    if (inputValue.length >= 3) {
      setLoading(true)
      handleSearchDestinatario(inputValue)
      setLoading(false)
    } else {
      setSearchResults([])
    }
  }

  useEffect(() => {
    const total = nfeItens.reduce(
      (acc, item) => acc + parseFloat(item.valortotalliquido || 0),
      0,
    )
    setTotalnfe(total)
  }, [nfeItens])

  const handleSearchWithTimeout = (value) => {
    clearTimeout(typingTimeout) // Limpa o timeout existente

    setTypingTimeout(
      setTimeout(() => {
        if (value.length >= 3) {
          setLoading(true) // Ativa o indicador de carregamento
          handleSearch().finally(() => setLoading(false)) // Desativa o indicador após a busca
        } else {
          setSearchResultsProd([])
        }
      }, TYPING_TIMEOUT),
    )
  }

  const handleSelectDestinatario = (result) => {
    // Aqui você pode fazer o que precisar com o destinatário selecionado
    setDestinatarioValue(result.pes_razao)
    setIdCliente(result.cod_pessoa)
    setLogradouro(result.pes_logradouro)
    setPesNum(result.pes_numero)
    setPesCidade(result.pes_cidade)
    setPEsBairro(result.pes_bairro)
    setIbge(result.pes_ibge)
    setUf(result.pes_uf)
    setCep(result.pes_cep)

    // Atualiza os campos do objeto endereco
    setEndereco({
      pes_razao: result.pes_razao,
      pes_logradouro: result.pes_logradouro,
      pes_numero: result.pes_numero,
      pes_cidade: result.pes_cidade,
      pes_bairro: result.pes_bairro,
      pes_ibge: result.pes_ibge,
      pes_uf: result.pes_uf,
      pes_cep: result.pes_cep,
      pes_cnpj_cpf: result.pes_cnpj_cpf,
      pes_insc_estadual: result.pes_insc_estadual,
      pes_celular: result.pes_celular,
      cod_tipo_contribuinte: result.cod_tipo_contribuinte,
      cod_pessoa: result.cod_pessoa,
      pes_tipo: result.pes_tipo,
    })

    setSearchResults([]) // Limpa a lista de resultados
  }

  const fetchNfe = async () => {
    try {
      setLoading(true)

      const response = await apinode.get(
        `/nfe/lista/${idnfe}/${localStorage.idconta}`,
      )

      const {
        numnfe,
        serie,
        pes_razao,
        datavenda,
        pes_cep,
        pes_logradouro,
        pes_numero,
        pes_bairro,
        pes_cidade,
        pes_uf,
        pes_ibge,
        codcliente,
        totalpedido,
        valorfrete,
        idtransportadora,
        natureza,
        volume,
        pesol,
        pesob,
        emp_conta,
        itens,
        tipo,
        erro,
        status,
        complemento,
        duplicatas,
        frete,
        chave,
        link_nfe,
      } = response.data[0]

      const dataFormatada = format(new Date(datavenda), 'yyyy-MM-dd')
      setLink(link_nfe)
      setNumeroNFe(numnfe)
      setDestinatarioValue(pes_razao)
      setDataVenda(dataFormatada)
      setSerie(serie)
      setCep(pes_cep)
      setLogradouro(pes_logradouro)
      setPesNum(pes_numero)
      setPEsBairro(pes_bairro)
      setPesCidade(pes_cidade)
      setUf(pes_uf)
      setIbge(pes_ibge)
      setIdCliente(codcliente)
      setEndereco(response.data[0].endereco)
      setTotalnfe(totalpedido)
      setNfeItens(itens)
      setFrete(valorfrete)
      setChave(chave)

      if (
        response.data[0]?.transportador &&
        response.data[0]?.transportador[0]?.pes_razao &&
        response.data[0]?.transportador[0]?.pes_cnpj_cpf
      ) {
        setNomeTransp(response.data[0].transportador[0].pes_razao)
        setCnpjTransp(response.data[0].transportador[0].pes_cnpj_cpf)
      } else {
        setNomeTransp(null)
        setCnpjTransp(null)
      }

      setIdTransp(idtransportadora || null)
      setVolume(volume)
      setPesol(pesol)
      setPesob(pesob)
      setNatureza(natureza)
      setEmpConta(emp_conta)
      setTipo(tipo)
      setErro(erro)
      setStatus(status)
      setLoading(false)
      setObservacaoInterna(complemento)
      setParcelas(duplicatas)
      setTipoFrete(frete)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao obter informação da NFe')
    } finally {
      setLoading(false)
    }
  }

  const handleConsultarStatus = async (id, contaEmp) => {
    try {
      setIsConsultarLoading(true)

      const response = await apinode.get(
        `/nfe/consultar/${id}/${contaEmp}/${localStorage.idconta}`,
      )

      await fetchNfe()

      setStatusConsultar(response.data)

      toast.success(response.data.message)
    } catch (err) {
      sendErrorApiMessage(erro, 'Erro ao consultar a nota')
    } finally {
      setIsConsultarLoading(false)
    }
  }

  const handleDadosFicais = async (id, contaEmp) => {
    try {
      setIsEnviarDadosLoading(true)

      await apinode.get(
        `/nfe/dadosfiscais/${id}/${contaEmp}/${localStorage.idconta}`,
      )

      toast.success('Dados fiscais enviados com sucesso!')
    } catch (error) {
      sendErrorApiMessage(erro, 'Erro ao enviar os dados fiscais')
    } finally {
      setIsEnviarDadosLoading(false)
    }
  }

  const updateLinkPrefix = (link) => {
    // Substituir o prefixo antigo pelo novo
    return link.replace(
      'http://erp.belahome.com.br:9091',
      'http://fiscal.ziphub.com.br',
    )
  }

  const handlePdf = (link, idnfe) => {
    setReload((prev) => !prev) // Toggle reload state to trigger useEffect
    if (!link || !link.includes('http://erp.belahome.com.br:9091')) {
      // Fazer uma requisição à API caso o link não contenha o prefixo esperado
      apinode({
        url: `/nfe/fiscal_pdf/${localStorage.idconta}`, // URL da API
        method: 'GET',
        params: {
          id: idnfe, // Passar o id da nota fiscal (NFE)
        },
      })
        .then((response) => {
          const html = response.data // Conteúdo HTML retornado
          const newWindow = window.open('', '_blank') // Abrir uma nova aba em branco
          newWindow.document.body.innerHTML = html // Inserir o HTML no body da nova aba

          // Chama a função de impressão para imprimir o conteúdo
          newWindow.print()
        })
        .catch((error) => {
          // Exibir mensagem de erro caso algo dê errado ao fazer a requisição
          console.error('Erro ao baixar o arquivo:', error)
        })
    } else {
      // Se o link contiver o prefixo esperado, abrir o PDF normalmente
      const updatedLink = updateLinkPrefix(link) // Atualizar o link com o novo prefixo
      window.open(updatedLink, '_blank') // Abrir o link atualizado em uma nova aba
    }
  }

  async function consultarNfe() {
    function tratarMensagemXML(mensagem) {
      if (typeof mensagem !== 'string') return mensagem

      // Expressão regular para remover as tags XML
      const mensagemSemTags = mensagem
        .replace(/<\/?[^>]+(>|$)/g, '') // Remove todas as tags XML
        .replace(/\n/g, '<br>') // Substitui quebras de linha por <br> para manter o formato no Swal
        .trim() // Remove espaços em branco no início e no final

      return mensagemSemTags
    }

    try {
      setTransmitting(true)

      const response = await apinode.post(
        `/nfe/validarxml/${idnfe}/${localStorage.idconta}/${localStorage.idconta}`,
      )

      await fetchNfe()

      const mensagemTratada = tratarMensagemXML(response.data)

      Swal.fire({
        title: 'Retorno da Validação',
        html: `<div style="text-align:left;">
        ${mensagemTratada}
                </div>`,
        icon: 'success',
        confirmButtonText: 'Ok',
      })
    } catch (error) {
      console.error('Erro ao validar NF-e:', error)

      const mensagemErroTratada = tratarMensagemXML(
        error.response?.data || 'Erro desconhecido',
      )

      Swal.fire({
        title: 'Erro ao validar NF-e',
        html: `<div style="text-align:left;">
        ${mensagemErroTratada}
                </div>`,
        icon: 'error', // Ícone de erro
        confirmButtonText: 'Tentar novamente',
      })
    } finally {
      setTransmitting(false)
    }
  }

  const EmitirNFe = async () => {
    setTransmitting(true)

    try {
      if (status === 'I') {
        toast.warning('NF-e cancelada!')
      } else if (status === 'T') {
        toast.warning('NF-e já transmitida')
        return
      } else {
        setShowModalTrans(true)
        setTransmitting(true)

        const response = await apinode.get(
          `/nfe/validanfe/${idnfe}/${localStorage.idconta}`,
        )
        if (response.data.match) {
          const emitResponse = await apinode.post(
            `/nfe/gerar/${idnfe}/${emp_conta}/${localStorage.idconta}/${localStorage.username}`,
          )
          if (emitResponse.data.status) {
            setResponseMessage('NFe Emitida com sucesso')
            setStatus('T')

            // Exibir o resultado em um modal SweetAlert2 com um botão de baixar PDF
            Swal.fire({
              title: 'NF-e Emitida',
              html: `<div style="text-align:left;">
                        ${tratarMensagemXML(emitResponse.data.message || 'NFe Emitida com sucesso!')}
                        </div>`,
              icon: 'success', // Ícone de sucesso
              showCancelButton: true, // Adiciona o botão "Cancelar"
              confirmButtonText: 'Ok',
              cancelButtonText: 'Baixar PDF',
            }).then((result) => {
              // Se o usuário clicar no botão de "Baixar PDF"
              if (result.dismiss === Swal.DismissReason.cancel) {
                handlePdf(linknfe, idnfe) // Função para baixar o PDF da NF-e
              }
            })

            return emitResponse.data
          } else {
            // Extrair e formatar a mensagem de erro
            const errorMsg = extractErrorMessage(emitResponse.data)

            setResponseMessage('Erro, ' + errorMsg)
            fetchNfe()
            toast.error('Erro ao emitir NF-e: ' + errorMsg)

            // Exibir o erro em um modal SweetAlert2
            Swal.fire({
              title: 'Erro ao Emitir NF-e',
              html: `<div style="text-align:left;">
${tratarMensagemXML(errorMsg)}
                        </div>`,
              icon: 'error', // Ícone de erro
              confirmButtonText: 'Ok',
            })
          }
        } else {
          let message = response.data.message

          // Exibe o erro na validação da NF-e
          setResponseMessage('Ocorreu um erro ao validar Nf-e: ' + message)
          fetchNfe()
          toast.error('Erro ao validar NF-e: ' + message)

          // Exibir o erro de validação da NF-e em um modal SweetAlert2
          Swal.fire({
            title: 'Erro na Validação da NF-e',
            html: `<div style="text-align:left;">
${tratarMensagemXML(message)}
                    </div>`,
            icon: 'error', // Ícone de erro
            confirmButtonText: 'Ok',
          })
        }
      }
    } catch (error) {
      // Tratar o erro de resposta do servidor e formatar apropriadamente
      const errorMsg = extractErrorMessage(
        error.response?.data || error.message,
      )
      setResponseMessage('Erro, ' + errorMsg)
      fetchNfe()
      toast.error('Erro ao emitir NF-e: ' + errorMsg)

      // Exibir o erro em um modal SweetAlert2
      Swal.fire({
        title: 'Erro ao Emitir NF-e',
        html: `<div style="text-align:left;">
${tratarMensagemXML(errorMsg)}
            </div>`,
        icon: 'error', // Ícone de erro
        confirmButtonText: 'Ok',
      })
    } finally {
      setTransmitting(false)
    }
  }

  // Função para tratar as mensagens, removendo ou destacando tags XML
  function tratarMensagemXML(mensagem) {
    if (typeof mensagem !== 'string') return mensagem

    // Expressão regular para remover as tags XML
    const mensagemSemTags = mensagem
      .replace(/<\/?[^>]+(>|$)/g, '') // Remove todas as tags XML
      .replace(/\n/g, '<br>') // Substitui quebras de linha por <br> para manter o formato no Swal
      .trim() // Remove espaços em branco no início e no final

    return mensagemSemTags
  }

  // Função para extrair e formatar a mensagem de erro de maneira clara
  const extractErrorMessage = (errorData) => {
    if (!errorData) return 'Erro desconhecido ao gerar NF-e'

    try {
      // Verifica se o erro é uma string JSON válida
      if (typeof errorData === 'string') {
        const parsedError = JSON.parse(errorData)
        if (parsedError.erro) {
          return parsedError.erro
        }
      }

      // Se for um objeto, verifica se tem campos como 'message' ou 'erro'
      if (typeof errorData === 'object') {
        return errorData.message || errorData.erro || JSON.stringify(errorData)
      }

      // Se for uma string simples, retorna como está
      return errorData
    } catch (e) {
      // Se falhar ao fazer o parsing, retorna o erro original
      return errorData
    }
  }

  const handleChangeOperacoes = async (id) => {
    try {
      const idconta = localStorage.getItem('idconta')
      if (!idconta) {
        throw new Error('idconta não encontrado no localStorage')
      }

      const response = await apinode.get(`/nfe/operacoes/${id}/${idconta}`)

      // Atualiza os produtos em nfeItens com base em response
      const novoArrayProdutos = nfeItens.map((produto, index) => {
        if (response.data[0]) {
          // Atualize os campos desejados do produto em nfeItens com base em response
          return {
            ...produto,
            csticms: response.data[0].cst,
            csosn: response.data[0].csosn,
            cfop: response.data[0].cfop,
          }
        }
        return produto
      })

      // Atualize o estado 'nfeItens' com o novo array de produtos atualizados
      setNfeItens(novoArrayProdutos)
    } catch (error) {
      console.error('Erro ao buscar dados:', error.message)
      // Tratar o erro, exibir uma mensagem, etc.
    }
  }

  const addNFeItensArray = (e) => {
    e.preventDefault()
    const index = nfeItens.findIndex((item) => item.id === editedItem.id)
    if (index !== -1) {
      const updatedItems = nfeItens.map((item, idx) => {
        if (idx === index) {
          return {
            ...editedItem,
            valortotalliquido: calculateTotalLiquido(),
            valortotal: calculateTotalItem(),
            valoricms:
              ((editedItem.bcicms || 0) * (editedItem.porcicms || 0)) / 100,
            valoripi:
              ((editedItem.valortotalliquido || 0) *
                (editedItem.porcipi || 0)) /
              100,
          }
        }
        return item
      })
      setNfeItens(updatedItems)
    }
    setShowModal(false)
  }

  const handleBCicms = () => {
    const valortotalliquido = document.getElementById(
      'formValorTotalLiquido',
    ).value
    setEditedItem({ ...editedItem, bcicms: valortotalliquido })
  }

  const [endereco, setEndereco] = useState({
    pes_logradouro: '',
    pes_numero: '',
    pes_cidade: '',
    pes_uf: '',
    pes_cep: '',
    pes_telefone: '',
    pes_celular: '',
    pes_tipo: 'F',
    pes_razao: '',
    pes_cnpj_cpf: '',
    cod_tipo_contribuinte: '99',
    pes_bairro: '',
    pes_ibge: '',
    pes_insc_estadual: '',
  })

  const handleSearch = async () => {
    setLoading(true) // Define o estado de loading como true antes da busca
    try {
      const response = await apinode.get('estoque/listaproduto', {
        params: {
          sku: editedItem.descricao,
          conta: localStorage.idconta,
        },
      })
      if (response.status !== 200) {
        throw new Error('Erro ao buscar dados')
      }
      setSearchResultsProd(response.data)
      setShowResults(true)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false) // Define o estado de loading como false após a busca, independentemente do resultado
    }
  }

  const handleSearchtTransp = async () => {
    try {
      const response = await apinode.get(
        `/nfe/listatransportador/${localStorage.idconta}`,
        {
          params: {
            dados: nomeTransp,
          },
        },
      )
      if (response.status !== 200) {
        throw new Error('Erro ao buscar dados')
      }
      setSearchResultsTrans(response.data)
    } catch (error) {
      console.error(error)
    }
  }

  const handleNomeChange = (e) => {
    setEndereco({
      ...endereco,
      pes_razao: e.target.value,
    })
  }

  const openEditModal = (item) => {
    setEditedItem(item)
    setShowModal(true)
  }

  const alternarItems = () => {
    const index = nfeItens.findIndex((item) => item.id === editedItem.id)
    if (index !== -1) {
      const updatedItems = [...nfeItens]
      updatedItems[index] = {
        ...editedItem,
        valortotalliquido: calculateTotalLiquido(),
        valortotal: calculateTotalItem(),
      }
      setNfeItens(updatedItems)
    }
  }

  const calcularTotalItensArray = () => {
    let totalItens = 0
    let totalItensLiquidos = 0
    const updatedItems = nfeItens.map((item) => {
      if (item.qtde && item.valorunitario) {
        let valorBruto = item.qtde * item.valorunitario
        let valorDesconto = item.desconto || 0
        let valorComDesconto = valorBruto - valorDesconto
        totalItensLiquidos += valorComDesconto
        totalItens += item.qtde * item.valorunitario
        return {
          ...item,
          valortotalliquido: valorComDesconto,
          valortotal: item.qtde * item.valorunitario,
        }
      } else {
        return item
      }
    })
    setNfeItens(updatedItems)
  }

  const calculateTotalLiquido = () => {
    if (!editedItem.qtde || !editedItem.valorunitario) return 0

    let valorBruto = editedItem.qtde * editedItem.valorunitario
    let valorDesconto = editedItem.desconto || 0
    let valorComDesconto = valorBruto - valorDesconto

    return valorComDesconto
  }

  const calculateTotalItem = () => {
    if (!editedItem.qtde || !editedItem.valorunitario) return 0
    return editedItem.qtde * editedItem.valorunitario
  }

  const handleCpfCnpjChange = (e) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, '') // Remove todos os caracteres não numéricos
    setEndereco({
      ...endereco,
      pes_cnpj_cpf: rawValue,
    })
  }

  const handleRuaChange = (e) => {
    setEndereco({ ...endereco, pes_logradouro: e.target.value })
  }

  const handleNumeroChange = (e) => {
    setEndereco({ ...endereco, pes_numero: e.target.value })
  }

  const handleCidadeChange = (e) => {
    setEndereco({ ...endereco, pes_cidade: e.target.value })
  }
  const handleRGIEChange = (e) => {
    setEndereco({ ...endereco, pes_insc_estadual: e.target.value })
  }
  const handleEstadoChange = (e) => {
    setEndereco({ ...endereco, pes_uf: e.target.value })
  }
  const handleBairroChange = (e) => {
    setEndereco({ ...endereco, pes_bairro: e.target.value })
  }

  const handleCepChange = (e) => {
    setEndereco({ ...endereco, pes_cep: e.target.value })
  }

  const handlePesIbge = (e) => {
    setEndereco({ ...endereco, pes_ibge: e.target.value })
  }

  const handleTelefoneChange = (e) => {
    setEndereco({ ...endereco, pes_telefone: e.target.value })
  }

  const handleCelularChange = (e) => {
    setEndereco({ ...endereco, pes_celular: e.target.value })
  }

  const handleTipoCadastroChange = (e) => {
    setEndereco({
      ...endereco,
      pes_tipo: e.target.value,
    })
  }

  const handleTipoContribuinte = (e) => {
    setEndereco({
      ...endereco,
      cod_tipo_contribuinte: e.target.value,
    })
  }

  const handleSelect = (selectedItem) => {
    setEditedItem({
      ...editedItem,
      idproduto: selectedItem.CODPRODUTO,
      descricao: selectedItem.DESCRICAO,
      qtde: 1, // ou outro valor padrão desejado
      valorunitario: selectedItem.PRECOVENDA,
      ncm: selectedItem.CODNCM,
      sku: selectedItem.SKU,
      unidade: selectedItem.UNIDADE,
      // outros campos necessários
    })
    setSearchResultsProd([])
  }

  const handleSelectTransp = (selectedItem) => {
    setIdTransp(selectedItem.cod_pessoa)
    setNomeTransp(selectedItem.pes_razao)
    setCnpjTransp(selectedItem.pes_cnpj_cpf)
    setSearchResultsTrans([])
  }

  function buscaCep() {
    const fornecedorCepInput = document.getElementById('cep')
    const cep = fornecedorCepInput.value.replace(/\D/g, '')
    const url = `https://viacep.com.br/ws/${cep}/json/`
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url)
    xhr.onload = function () {
      const response = JSON.parse(xhr.responseText)
      setEndereco({
        ...endereco,
        pes_ibge: response.ibge,
        pes_bairro: response.bairro,
        pes_cidade: response.localidade,
        pes_uf: response.uf,
        pes_logradouro: response.logradouro,
      })
    }
    xhr.send()
  }

  useEffect(() => {
    if (idnfe !== 'novo') {
      fetchNfe()
    }
  }, [idnfe, reload]) // Add reload to the dependency array

  const HandleCadastrarCliente = (e) => {
    e.preventDefault()
    apinode
      .post(`pessoa/${localStorage.idconta}`, endereco)
      .then((response) => {
        toast.success('Cliente cadastrado com sucesso!')
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
        toast.error('Erro, ' + error.response.data.message)
        // Handle the error appropriately here
        setLoading(false)
      })
  }

  const handleOpenAddressModal = () => {
    setShowAddressModal(true)
  }
  const handleCloseAddressModal = () => {
    setShowAddressModal(false)
  }

  const handleNatureza = (selectedNatureza) => {
    setNatureza(selectedNatureza)
    handleChangeOperacoes(selectedNatureza)
  }

  const handleDelete = (id) => {
    const isConfirmed = window.confirm(
      'Tem certeza de que deseja excluir este item?',
    )
    if (isConfirmed) {
      const updatedItems = nfeItens.filter((item) => item.id !== id)
      setNfeItens(updatedItems)
    }
  }

  let idCounter = idnfe + 1 // Inicializa o contador com 1

  const handleAddItem = () => {
    const newItem = {
      id: uuidv4(), // Usa o valor atual do contador como ID
      descricao: '',
      qtde: 0,
      valorunitario: 0,
      ncm: '',
      idnfe: idnfe,
    }

    setNfeItens([...nfeItens, newItem])
    openEditModal(newItem) // Passando o novo item para a função openEditModal
  }

  /*
        const handleAddItem = () => {
            const newItem = {
                id: uuidv4(),
                descricao: '',
                qtde: 0,
                valorunitario: 0,
                ncm: ''
            };
            setNfeItens([...nfeItens, newItem]);
        }; */

  const handleSubmit = (event) => {
    event.preventDefault()
    // Lógica para a emissão da NF-e
    // Adicione a lógica real para a emissão da NF-e aqui
  }

  return (
    <ContentLoading
      isLoading={loading}
      loadingText="Carregando nota fiscal..."
    >
      <>
        <Navbar />

        <div className="container mt-page">
          <div className="d-flex justify-content-between">
            <h1>Edição e Emissão da NF-e</h1>
            <div style={{ marginRight: '20px' }}>
              <h1>{getStatusLabel(status)}</h1>
            </div>
          </div>
          {erro && status !== 'T' && (
            <div style={{ marginRight: '20px' }}>
              <Alert variant="danger">{erro}</Alert>
            </div>
          )}

          <Form onSubmit={handleSubmit}>
            <Card
              className="marginRight"
              style={{ marginRight: '20px' }}
            >
              <CardBody>
                <Row>
                  <Col md={2}>
                    <Form.Group controlId="formTipo">
                      <Form.Label
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        Tipo
                      </Form.Label>
                      <Form.Select
                        value={tipo}
                        onChange={(e) => setTipo(e.target.value)}
                        className="form-select form-select-sm"
                      >
                        <option value="S">Saída</option>
                        <option value="E">Entrada</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group controlId="formNumeroNFe">
                      <Form.Label
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        Número da NF-e
                      </Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        placeholder="Número da NF-e"
                        value={numeroNFe}
                        onChange={(e) => setNumeroNFe(e.target.value)}
                        className="form-control form-control-sm"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={1}>
                    <Form.Group controlId="formSerie">
                      <Form.Label
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        Série
                      </Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        placeholder="Série"
                        value={serie}
                        onChange={(e) => setSerie(e.target.value)}
                        className="form-control form-control-sm"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group controlId="formNatureza">
                      <Form.Label
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        Natureza da NF-e
                      </Form.Label>
                      <select
                        className="form-control form-control-sm"
                        id="NATUREZA"
                        name="NATUREZA"
                        size="1"
                        tabIndex="1"
                        value={natureza}
                        onChange={(event) => handleNatureza(event.target.value)} // Correção aqui
                      >
                        <option value="120">SIMPLES REMESSA</option>
                        <option value="110">VENDA DE MERCADORIAS</option>
                        <option value="116">
                          VENDA ESTADUAL PESSOA FISICA
                        </option>
                        <option value="118">
                          VENDA ESTADUAL PESSOA JURIDICA
                        </option>
                        <option value="117">
                          VENDA FORA DO ESTADO PESSOA FISICA
                        </option>
                        <option value="119">
                          VENDA FORA DO ESTADO PESSOA JURIDICA
                        </option>
                        <option value="112">BONIFICACAO</option>
                        <option value="111">DEVOLUCAO DE VENDA</option>
                        <option value="115">DEVOLUCAO DE MERCADORIA</option>
                        <option value="113">
                          REMESSA DE MERCADORIA OU BEM PARA CONSERTO OU REPARO
                        </option>
                        <option value="114">
                          OUTRA SAIDA DE MERCAD. OU PRESTAÇÃO DE SERV. NÃO ESPEC
                        </option>
                      </select>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group controlId="datavenda">
                      <Form.Label
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        Data Venda
                      </Form.Label>
                      <Form.Control
                        type="date"
                        value={datavenda}
                        onChange={(e) => setDataVenda(e.target.value)}
                        className="form-control form-control-sm"
                      />
                    </Form.Group>
                  </Col>

                  <Col
                    md={2}
                    className="mt-2"
                  >
                    <Form.Group controlId="Conta">
                      <Form.Label
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        Conta
                      </Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        value={emp_conta}
                        onChange={(e) => setEmpConta(e.target.value)}
                        className="form-control form-control-sm"
                      />
                    </Form.Group>
                  </Col>

                  <Col
                    md={5}
                    className="mt-2"
                  >
                    <Form.Group controlId="Conta">
                      <Form.Label
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        Chave de Acesso
                      </Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        value={chave}
                        onChange={(e) => setChave(e.target.value)}
                        className="form-control form-control-sm"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form>
                      <Form.Group
                        controlId="formDestinatario"
                        className="mt-3"
                      >
                        <Form.Label
                          style={{ fontSize: '12px', fontWeight: 'bold' }}
                        >
                          Destinatário
                        </Form.Label>
                        <div className="input-group">
                          <Form.Control
                            type="text"
                            value={destinatarioValue}
                            onChange={handleInputChangeDestinatario}
                            placeholder="Pesquisar destinatário"
                            className="form-control form-control-sm"
                          />
                          <Button
                            variant="primary"
                            className="btn-sm"
                            onClick={handleOpenAddressModal}
                            title="Pesquisar destinatário"
                          >
                            <FontAwesomeIcon icon={faEye} />
                          </Button>
                        </div>
                      </Form.Group>

                      {searchResults.length > 0 && (
                        <ul style={{ listStyleType: 'none', padding: 0 }}>
                          {searchResults.map((result) => (
                            <li
                              key={result.cod_pessoa}
                              onClick={() => handleSelectDestinatario(result)}
                              style={{
                                padding: '5px',
                                borderBottom: '1px solid #ccc',
                                cursor: 'pointer',
                              }}
                            >
                              <span
                                style={{ marginLeft: '15px', fontSize: '10px' }}
                              >
                                {result.pes_razao} - {result.pes_cnpj_cpf}
                              </span>
                            </li>
                          ))}
                        </ul>
                      )}
                    </Form>
                  </Col>
                </Row>

                <Row>
                  <Col md={2}>
                    <Form.Group
                      controlId="formInput"
                      className="mt-3"
                    >
                      <Form.Label
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        Cep
                      </Form.Label>
                      <div className="input">
                        <Form.Control
                          type="text"
                          value={cep}
                          onChange={(e) => setCep(e.target.value)}
                          placeholder="Cep"
                          className="form-control form-control-sm"
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group
                      controlId="formInput"
                      className="mt-3"
                    >
                      <Form.Label
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        logradouro
                      </Form.Label>
                      <div className="input">
                        <Form.Control
                          type="text"
                          value={logradouro}
                          onChange={(e) => setLogradouro(e.target.value)}
                          placeholder="logradouro"
                          className="form-control form-control-sm"
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={1}>
                    <Form.Group
                      controlId="formInput"
                      className="mt-3"
                    >
                      <Form.Label
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        Numero
                      </Form.Label>
                      <div className="input">
                        <Form.Control
                          type="text"
                          value={pesNum}
                          onChange={(e) => setPesNum(e.target.value)}
                          placeholder="logradouro"
                          className="form-control form-control-sm"
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group
                      controlId="formInput"
                      className="mt-3"
                    >
                      <Form.Label
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        Bairro
                      </Form.Label>
                      <div className="input">
                        <Form.Control
                          type="text"
                          value={pesBairro}
                          onChange={(e) => setBairro(e.target.value)}
                          placeholder="Bairro"
                          className="form-control form-control-sm"
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Row>
                    <Col md={3}>
                      <Form.Group
                        controlId="formInput"
                        className="mt-3"
                      >
                        <Form.Label
                          style={{ fontSize: '12px', fontWeight: 'bold' }}
                        >
                          Cidade
                        </Form.Label>
                        <div className="input">
                          <Form.Control
                            type="text"
                            value={pesCidade}
                            onChange={(e) => setPesCidade(e.target.value)}
                            placeholder="Cidade"
                            className="form-control form-control-sm"
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group
                        controlId="formInput"
                        className="mt-3"
                      >
                        <Form.Label
                          style={{ fontSize: '12px', fontWeight: 'bold' }}
                        >
                          Ibge
                        </Form.Label>
                        <div className="input">
                          <Form.Control
                            type="text"
                            value={codIbge}
                            onChange={(e) => setIbge(e.target.value)}
                            placeholder="Ibge"
                            className="form-control form-control-sm"
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={1}>
                      <Form.Group
                        controlId="formInput"
                        className="mt-3"
                      >
                        <Form.Label
                          style={{ fontSize: '12px', fontWeight: 'bold' }}
                        >
                          UF
                        </Form.Label>
                        <div className="input">
                          <Form.Control
                            type="text"
                            value={uf}
                            onChange={(e) => setUf(e.target.value)}
                            placeholder="Ibge"
                            className="form-control form-control-sm"
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </Row>
                <Row className="mt-1">
                  <h4
                    style={{ fontSize: '14px' }}
                    className="mt-4"
                  >
                    Itens da NFe
                  </h4>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={handleAddItem}
                    style={{ float: 'right', width: 'fit-content' }}
                    className="d-block"
                  >
                    <span className="bi bi-plus"></span> Adicionar Item
                  </Button>
                  <div className="table-responsive">
                    <Table
                      striped
                      hover
                      bordered
                      size="sm"
                      style={{ fontSize: '8px' }}
                    >
                      {/* Cabeçalho da Tabela */}
                      <thead>
                        <tr>
                          <th>Ação</th>
                          <th>ID NFe</th>
                          <th>ID Produto</th>
                          <th>Descrição</th>
                          <th>NCM</th>
                          <th>CST ICMS</th>
                          <th>CSOSN</th>
                          <th>CFOP</th>
                          <th>Unidade</th>
                          <th>Quantidade</th>
                          <th>Valor Unitário</th>
                          <th>Desconto</th>
                          <th>Valor Total</th>
                          <th>Valor Total Líquido</th>
                          <th>BC ICMS</th>
                          <th>Porcentagem ICMS</th>
                          <th>Valor ICMS</th>
                          <th>Porcentagem IPI</th>
                          <th>Valor IPI</th>
                          <th>BC ICMS ST</th>
                          <th>Valor ICMS ST</th>
                          <th>Porc. Estadual</th>
                        </tr>
                      </thead>
                      {/* Corpo da Tabela */}
                      <tbody>
                        {nfeItens.map((item) => (
                          <tr key={item.id}>
                            <td style={{ display: 'flex', gap: '0px' }}>
                              <Button
                                variant="warning"
                                size="sm"
                                onClick={() => openEditModal(item)}
                                style={{
                                  padding: '0.2rem 0.4rem',
                                  fontSize: '0.70rem',
                                }}
                              >
                                <FaEdit />
                              </Button>
                              <Button
                                variant="danger"
                                size="sm"
                                onClick={() => handleDelete(item.id)}
                                title="Excluir"
                                style={{
                                  padding: '0.2rem 0.4rem',
                                  fontSize: '0.70rem',
                                }}
                              >
                                <FaTrash />
                              </Button>
                            </td>

                            <td>{item.idnfe}</td>
                            <td>{item.idproduto}</td>
                            <td style={{ whiteSpace: 'nowrap' }}>
                              {' '}
                              {item.sku} - {item.descricao}
                            </td>
                            <td>{item.ncm}</td>
                            <td>{item.csticms}</td>
                            <td>{item.csosn}</td>
                            <td>{item.cfop}</td>
                            <td>{item.unidade}</td>
                            <td>{item.qtde}</td>
                            <td>{item.valorunitario}</td>
                            <td>{item.desconto}</td>
                            <td>{item.valortotal}</td>
                            <td>{item.valortotalliquido}</td>
                            <td>{item.bcicms}</td>
                            <td>{item.porcicms}</td>
                            <td>
                              {item.valoricms != null
                                ? item.valoricms.toFixed(2)
                                : null}
                            </td>
                            <td>{item.porcipi}</td>
                            <td>{item.valoripi}</td>
                            <td>{item.bcicmsst}</td>
                            <td>{item.valoricmsst}</td>
                            <td>{item.porcicmsest}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>

                    <button onClick={calcularTotalItensArray}>
                      Calcular Totais
                    </button>
                  </div>
                </Row>

                <Row className="mt-1">
                  <Row>
                    <Col
                      xs={12}
                      sm={6}
                    >
                      <div className="form-group mt-4">
                        <Form.Label
                          style={{ fontSize: '12px', fontWeight: 'bold' }}
                        >
                          Tipo de Frete
                        </Form.Label>
                        <select
                          id="FRETE"
                          name="FRETE"
                          size="1"
                          tabIndex="16"
                          className="form-control form-control-sm"
                          value={tipoFrete}
                          onChange={(event) => setTipoFrete(event.target.value)} // Corrigido aqui
                        >
                          <option value="-1">-- Não Selecionado --</option>
                          <option value="0">
                            0 - Contratação do Frete por conta do Remetente
                            (CIF)
                          </option>
                          <option value="1">
                            1 - Contratação do Frete por conta do Destinatário
                            (FOB)
                          </option>
                          <option value="2">
                            2 - Contratação do Frete por conta de Terceiros
                          </option>
                          <option value="3">
                            3 - Transporte Próprio por conta do Remetente
                          </option>
                          <option value="4">
                            4 - Transporte Próprio por conta do Destinatário
                          </option>
                          <option value="9">
                            9 - Sem Ocorrência de Transporte
                          </option>
                        </select>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <h4
                      style={{ fontSize: '14px' }}
                      className="mt-4"
                    >
                      Dados Transportador
                    </h4>
                    <Col md={2}>
                      <Form.Group
                        controlId="formInput"
                        className="mt-3"
                      >
                        <Form.Label
                          style={{ fontSize: '12px', fontWeight: 'bold' }}
                        >
                          Frete
                        </Form.Label>
                        <div className="input">
                          <Form.Control
                            type="text"
                            value={frete}
                            onChange={(e) => setFrete(e.target.value)}
                            placeholder="Frete"
                            className="form-control form-control-sm"
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group
                        controlId="formCnpjTransp"
                        className="mt-3"
                      >
                        <Form.Label
                          style={{ fontSize: '12px', fontWeight: 'bold' }}
                        >
                          CPF/CNPJ
                        </Form.Label>
                        <div className="input">
                          <Form.Control
                            disabled
                            type="text"
                            value={cnpjTransp}
                            onChange={(e) => setCnpjTransp(e.target.value)}
                            placeholder="CPF/CNPJ"
                            className="form-control form-control-sm"
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={8}>
                      <Form.Group
                        controlId="formTransp"
                        className="mt-3"
                      >
                        <Form.Label
                          style={{ fontSize: '12px', fontWeight: 'bold' }}
                        >
                          Descrição
                        </Form.Label>
                        <div style={{ position: 'relative', width: '100%' }}>
                          <Form.Control
                            type="text"
                            placeholder="Transportador"
                            style={{
                              fontSize: '12px',
                              padding: '6px',
                              height: '30px',
                            }}
                            value={nomeTransp}
                            onChange={(e) => {
                              const inputValue = e.target.value
                              setNomeTransp(inputValue)
                              if (inputValue.length >= 3) {
                                handleSearchtTransp()
                              } else {
                                setSearchResultsTrans([])
                              }
                            }}
                          />
                          {searchResultsTrans.length > 0 && (
                            <Table
                              striped
                              hover
                              style={{
                                fontSize: '14px',
                                position: 'absolute',
                                top: '100%',
                                left: 0,
                                width: '100%',
                                height: `${Math.min(searchResultsTrans.length, 5) * 150}px`, // Ajuste o valor 20 conforme necessário e o número 5 para o máximo de resultados visíveis
                                display:
                                  nomeTransp.length >= 3 ? 'block' : 'none',
                                zIndex: 999,
                              }}
                            >
                              <thead>
                                <tr>
                                  <th>CNPJ</th>
                                  <th>Razão Social</th>
                                  <th>COD.</th>
                                </tr>
                              </thead>
                              <tbody>
                                {searchResultsTrans.map((result) => (
                                  <tr
                                    key={result.cod_pessoa}
                                    onClick={() => {
                                      handleSelectTransp(result)
                                      setSearchResults([])
                                    }}
                                  >
                                    <td>{result.pes_cnpj_cpf}</td>
                                    <td>{result.pes_razao}</td>
                                    <td>{result.cod_pessoa}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          )}
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group
                        controlId="formCnpjTransp"
                        className="mt-3"
                      >
                        <Form.Label
                          style={{ fontSize: '12px', fontWeight: 'bold' }}
                        >
                          Volume
                        </Form.Label>
                        <div className="input">
                          <Form.Control
                            type="text"
                            value={volume}
                            onChange={(e) => setVolume(e.target.value)}
                            placeholder="Volume"
                            className="form-control form-control-sm"
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group
                        controlId="formCnpjTransp"
                        className="mt-3"
                      >
                        <Form.Label
                          style={{ fontSize: '12px', fontWeight: 'bold' }}
                        >
                          Peso Liq.
                        </Form.Label>
                        <div className="input">
                          <Form.Control
                            type="text"
                            value={pesol}
                            onChange={(e) => setPesol(e.target.value)}
                            placeholder="Peso Liquido"
                            className="form-control form-control-sm"
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group
                        controlId="formCnpjTransp"
                        className="mt-3"
                      >
                        <Form.Label
                          style={{ fontSize: '12px', fontWeight: 'bold' }}
                        >
                          Peso Bruto.
                        </Form.Label>
                        <div className="input">
                          <Form.Control
                            type="text"
                            value={pesob}
                            onChange={(e) => setPesob(e.target.value)}
                            placeholder="Peso Bruto"
                            className="form-control form-control-sm"
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </Row>

                <Col md={2}>
                  <Form.Group
                    controlId="formInput"
                    className="mt-3"
                  >
                    <Form.Label
                      style={{ fontSize: '12px', fontWeight: 'bold' }}
                    >
                      Total Nfe
                    </Form.Label>
                    <div className="input">
                      <Form.Control
                        disabled
                        type="text"
                        value={nfeItens
                          .reduce(
                            (total, item) =>
                              total + parseFloat(item.valortotalliquido || 0),
                            0,
                          )
                          .toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        placeholder="Totais"
                        className="form-control form-control-sm"
                      />
                    </div>
                  </Form.Group>
                </Col>

                <h4
                  style={{ fontSize: '14px' }}
                  className="mt-2"
                >
                  informações adicionais
                </h4>
                <Col>
                  <Form.Control
                    style={{ fontSize: '11px' }}
                    as="textarea"
                    rows={3}
                    placeholder="Digite aqui..."
                    value={observacaoInterna}
                    onChange={(e) => setObservacaoInterna(e.target.value)}
                  />
                </Col>
                <div className="row mb-3 mt-3">
                  <div className="col-md-6">
                    <label
                      htmlFor="diasParcelas"
                      style={{ color: '#999999' }}
                      className="form-label"
                    >
                      Dias para as Parcelas (separados por vírgula):
                    </label>
                    <div className="input-group">
                      <input
                        type="text"
                        id="diasParcelas"
                        value={diasParcelas}
                        onChange={(e) => setDiasParcelas(e.target.value)}
                        size={'sm'}
                        className="form-control form-control-sm"
                      />
                      <button
                        className="btn btn-primary"
                        type="button"
                        onClick={calcularParcelas}
                      >
                        Calcular Parcelas
                      </button>
                    </div>
                  </div>
                </div>
                <div className="mt-4">
                  <h4
                    style={{ fontSize: '14px' }}
                    className="mt-2"
                  >
                    Parcelas:
                  </h4>
                  <table
                    className="table table-sm"
                    style={{ fontSize: '12px' }}
                  >
                    <thead>
                      <tr>
                        <th>Parcela</th>
                        <th>Vencimento</th>
                        <th>Valor</th>
                        <th>Anotações</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {parcelas.map((parcela) => (
                        <tr key={parcela.codigo}>
                          <td>{parcela.num_parcela}</td>
                          <td>
                            {parcela.data
                              ? format(new Date(parcela.data), 'dd/MM/yyyy')
                              : ''}
                          </td>
                          <td>
                            <input
                              type="text"
                              value={
                                parcela.valor === null
                                  ? ''
                                  : parcela.valor.toLocaleString('pt-BR', {
                                      style: 'currency',
                                      currency: 'BRL',
                                    })
                              }
                              onChange={(e) => {
                                const newValue = e.target.value
                                  .replace(/[^\d.,]/g, '')
                                  .replace(',', '.') // Substitui vírgula por ponto
                                handeleditarValor(parcela.num_parcela, newValue)
                              }}
                              className="form-control"
                              style={{ fontSize: '12px', width: '80px' }}
                              readOnly={false}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              value={parcela.obs}
                              onChange={(e) =>
                                handleEditarObservacao(
                                  parcela.num_parcela,
                                  e.target.value,
                                )
                              }
                              className="form-control"
                              style={{ fontSize: '12px' }}
                            />
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() =>
                                handleExcluirParcela(parcela.codigo)
                              }
                              style={{ fontSize: '12px' }}
                            >
                              Excluir
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>

            {/* Adicione campos para itens, totais e impostos conforme necessário */}
            {/*     <Button variant="primary" type="submit">
                    Emitir NF-e
                </Button>
                        */}
          </Form>

          <Modal
            show={showAddressModal}
            onHide={handleCloseAddressModal}
            dialogClassName="custom-modalzpl"
          >
            <form onSubmit={HandleCadastrarCliente}>
              <Modal.Header>
                <Modal.Title>Dados do Cliente</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row g-3">
                  <div className="col-md-2 mb-3">
                    <label
                      htmlFor="tipoCadastro"
                      className="form-label"
                    >
                      Tipo de Cadastro:
                    </label>
                    <select
                      className="form-select"
                      id="tipoCadastro"
                      value={endereco.pes_tipo}
                      onChange={handleTipoCadastroChange}
                    >
                      <option value="F">Pessoa Física</option>
                      <option value="J">Pessoa Jurídica</option>
                    </select>
                  </div>
                  <div className="col-md-2 mb-3">
                    <label
                      htmlFor="tipoCadastro"
                      className="form-label"
                    >
                      Contribuinte:
                    </label>
                    <select
                      className="form-control"
                      id="TipoContribuinte"
                      size="1"
                      value={endereco.cod_tipo_contribuinte}
                      onChange={handleTipoContribuinte}
                    >
                      <option value="1">CONTRIBUINTE ICMS</option>
                      <option value="2">CONTRIBUINTE ISENTO</option>
                      <option value="9">NAO CONTRIBUINTE</option>
                      <option value="99">NAO SELECIONADO</option>
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label
                      htmlFor="nome"
                      className="form-label"
                    >
                      {endereco.pes_tipo === 'F' ? 'Nome' : 'Nome da Empresa'}:
                    </label>
                    <input
                      required="true"
                      type="text"
                      className="form-control"
                      id="nome"
                      value={endereco.pes_razao}
                      onChange={handleNomeChange}
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label
                      htmlFor="cpfCnpj"
                      className="form-label"
                    >
                      {endereco.pes_tipo === 'F' ? 'CPF' : 'CNPJ'}:
                    </label>
                    <ReactInputMask
                      mask={
                        endereco.pes_tipo === 'F'
                          ? '999.999.999-99'
                          : '99.999.999/9999-99'
                      }
                      maskChar={null} // Remove os caracteres de espaço reservado (_)
                      value={endereco.pes_cnpj_cpf}
                      onChange={handleCpfCnpjChange}
                      className="form-control"
                      id="cpfCnpj"
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label
                      htmlFor="rgie"
                      className="form-label"
                    >
                      {endereco.pes_tipo === 'F' ? 'RG' : 'Insc. Estadual'}:
                    </label>
                    <input
                      value={endereco.pes_insc_estadual}
                      onChange={handleRGIEChange}
                      className="form-control"
                      id="rgie"
                    />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label
                      htmlFor="cep"
                      className="form-label"
                    >
                      CEP:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="cep"
                      value={endereco.pes_cep}
                      onChange={handleCepChange}
                      onBlur={buscaCep}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label
                      htmlFor="rua"
                      className="form-label"
                    >
                      Rua:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="rua"
                      value={endereco.pes_logradouro}
                      onChange={handleRuaChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label
                      htmlFor="rua"
                      className="form-label"
                    >
                      Bairro:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="bairro"
                      value={endereco.pes_bairro}
                      onChange={handleBairroChange}
                    />
                  </div>
                  <div className="col-md-2 mb-3">
                    <label
                      htmlFor="numero"
                      className="form-label"
                    >
                      Número:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="numero"
                      value={endereco.pes_numero}
                      onChange={handleNumeroChange}
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label
                      htmlFor="cidade"
                      className="form-label"
                    >
                      Cidade:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="cidade"
                      value={endereco.pes_cidade}
                      onChange={handleCidadeChange}
                    />
                  </div>
                  <div className="col-md-2 mb-3">
                    <label
                      htmlFor="estado"
                      className="form-label"
                    >
                      Estado:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="estado"
                      value={endereco.pes_uf}
                      onChange={handleEstadoChange}
                    />
                  </div>

                  <div className="col-md-2 mb-3">
                    <label
                      htmlFor="estado"
                      className="form-label"
                    >
                      Ibge:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="ibge"
                      value={endereco.pes_ibge}
                      onChange={handlePesIbge}
                    />
                  </div>

                  <div className="col-md-2 mb-3">
                    <label
                      htmlFor="telefone"
                      className="form-label"
                    >
                      Telefone:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="telefone"
                      value={endereco.pes_telefone}
                      onChange={handleTelefoneChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label
                      htmlFor="celular"
                      className="form-label"
                    >
                      Celular:
                    </label>
                    <InputMask
                      mask="(99) 99999-9999"
                      maskChar="_"
                      className="form-control"
                      id="celular"
                      value={endereco.pes_celular}
                      onChange={handleCelularChange}
                    />
                  </div>
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  variant="success"
                  type="submit"
                >
                  Cadastrar Cliente / Editar
                </Button>

                <Button
                  variant="secondary"
                  onClick={handleCloseAddressModal}
                >
                  Fechar
                </Button>
              </Modal.Footer>
            </form>
          </Modal>

          <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            dialogClassName="custom-modalzpl"
          >
            <Form onSubmit={addNFeItensArray}>
              <Modal.Header>
                <Modal.Title>Editar Item</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {editedItem && (
                  <>
                    <Form.Group
                      className="mb-3"
                      controlId="formDescricao"
                    >
                      <Form.Label
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        Descrição
                      </Form.Label>
                      <div style={{ position: 'relative', width: '100%' }}>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Descrição"
                          style={{
                            fontSize: '12px',
                            padding: '6px',
                            height: '30px',
                          }}
                          value={editedItem.descricao}
                          onChange={(e) => {
                            const inputValue = e.target.value
                            setEditedItem({
                              ...editedItem,
                              descricao: inputValue,
                            })
                            // Chamada da função com o valor atualizado
                            handleSearchWithTimeout(inputValue)
                          }}
                          autoComplete="off" // Desativa o preenchimento automático
                        />
                        {searchResultsProd.length > 0 && (
                          <div
                            style={{
                              position: 'absolute',
                              top: 'calc(100% + 5px)',
                              left: 0,
                              width: '100%',
                              maxHeight: '200px',
                              overflowY: 'auto',
                              border: '1px solid #ced4da',
                              borderRadius: '4px',
                              boxShadow: '0 2px 4px rgba(0,0,0,.1)',
                              backgroundColor: '#fff',
                              zIndex: 999,
                            }}
                          >
                            <Table
                              striped
                              hover
                              style={{ fontSize: '14px' }}
                            >
                              <thead>
                                <tr>
                                  <th>ID</th>
                                  <th>Descrição</th>
                                  <th>Preço</th>
                                </tr>
                              </thead>
                              <tbody>
                                {searchResultsProd.map((result) => (
                                  <tr
                                    key={result.CODPRODUTO}
                                    onClick={() => {
                                      handleSelect(result)
                                      setSearchResults([])
                                    }}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    <td>{result.SKU}</td>
                                    <td>{result.DESCRICAO}</td>
                                    <td>{result.PRECOVENDA.toFixed(2) || 0}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        )}
                      </div>
                    </Form.Group>
                    <Row>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formQuantidade"
                        >
                          <Form.Label
                            style={{ fontSize: '12px', fontWeight: 'bold' }}
                          >
                            Quantidade
                          </Form.Label>
                          <Form.Control
                            required
                            style={{
                              fontSize: '12px',
                              padding: '6px',
                              height: '30px',
                            }}
                            type="text"
                            onBlur={() => alternarItems()}
                            placeholder="Quantidade"
                            value={(editedItem.qtde || 1)
                              .toString()
                              .replace(',', '.')}
                            onChange={(e) =>
                              setEditedItem({
                                ...editedItem,
                                qtde: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formValorUnitario"
                        >
                          <Form.Label
                            style={{ fontSize: '12px', fontWeight: 'bold' }}
                          >
                            Valor Unitário
                          </Form.Label>
                          <Form.Control
                            style={{
                              fontSize: '12px',
                              padding: '6px',
                              height: '30px',
                            }}
                            type="text"
                            placeholder="Valor Unitário"
                            value={(editedItem.valorunitario || 0)
                              .toString()
                              .replace(',', '.')}
                            onChange={(e) =>
                              setEditedItem({
                                ...editedItem,
                                valorunitario: e.target.value.replace(',', '.'),
                              })
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formDesconto"
                        >
                          <Form.Label
                            style={{ fontSize: '12px', fontWeight: 'bold' }}
                          >
                            Desconto (%)
                          </Form.Label>
                          <Form.Control
                            style={{
                              fontSize: '12px',
                              padding: '6px',
                              height: '30px',
                            }}
                            type="text"
                            placeholder="Desconto"
                            value={editedItem.desconto || ''}
                            onChange={(e) =>
                              setEditedItem({
                                ...editedItem,
                                desconto: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formValorTotalLiquido"
                        >
                          <Form.Label
                            style={{ fontSize: '12px', fontWeight: 'bold' }}
                          >
                            Valor Total
                          </Form.Label>
                          <Form.Control
                            style={{
                              fontSize: '12px',
                              padding: '6px',
                              height: '30px',
                            }}
                            disabled
                            type="text"
                            placeholder="Valor Total Líquido"
                            value={
                              (
                                editedItem.valorunitario * editedItem.qtde
                              ).toFixed(2) || ''
                            }
                            onChange={(e) =>
                              setEditedItem({
                                ...editedItem,
                                valortotalliquido: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group
                      className="mb-3"
                      controlId="formNcm"
                    >
                      <Form.Label
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        NCM
                      </Form.Label>
                      <Form.Control
                        type="text"
                        style={{
                          fontSize: '12px',
                          padding: '6px',
                          height: '30px',
                        }}
                        placeholder="NCM"
                        value={editedItem.ncm}
                        onChange={(e) =>
                          setEditedItem({ ...editedItem, ncm: e.target.value })
                        }
                      />
                    </Form.Group>
                    <Row>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formCstIcms"
                        >
                          <Form.Label
                            style={{ fontSize: '12px', fontWeight: 'bold' }}
                          >
                            CST ICMS
                          </Form.Label>
                          <select
                            className="form-select"
                            value={editedItem.csticms}
                            onChange={(e) =>
                              setEditedItem({
                                ...editedItem,
                                csticms: e.target.value,
                              })
                            }
                          >
                            <option value="-1">
                              -- Selecione uma Opção --
                            </option>
                            <option value="4">
                              00-Tributada integralmente
                            </option>
                            <option value="14">
                              10-Tributada e com cobrança do ICMS por
                              substituição tributária
                            </option>
                            <option value="15">20-Com redução da BC</option>
                            <option value="16">
                              30-Isenta / não tributada e com cobrança do ICMS
                              por substituição tributária
                            </option>
                            <option value="5">40-Isenta</option>
                            <option value="17">41-Não tributada</option>
                            <option value="18">50-Com suspensão</option>
                            <option value="19">51-Com diferimento</option>
                            <option value="20">
                              60-ICMS cobrado anteriormente por substituição
                              tributária
                            </option>
                            <option value="21">
                              70-Com redução da BC e cobrança do ICMS por
                              substituição tributária
                            </option>
                            <option value="22">90-Outras</option>
                          </select>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Col>
                          <Form.Group
                            className="mb-3"
                            controlId="formCSOSN"
                          >
                            <Form.Label
                              style={{ fontSize: '12px', fontWeight: 'bold' }}
                            >
                              CSOSN
                            </Form.Label>

                            <select
                              className="form-select"
                              value={editedItem.csosn}
                              onChange={(e) =>
                                setEditedItem({
                                  ...editedItem,
                                  csosn: e.target.value,
                                })
                              }
                            >
                              <option value="-1">
                                -- Selecione uma Opção --
                              </option>
                              <option value="6">
                                101-Tributada pelo Simples Nacional com
                                permissão de crédito
                              </option>
                              <option value="7">
                                102-Tributada pelo Simples Nacional sem
                                permissão de crédito
                              </option>
                              <option value="8">
                                103-Isenção do ICMS no Simples Nacional para
                                faixa de receita bruta
                              </option>
                              <option value="23">
                                201-Tributada pelo Simples Nacional com
                                permissão de crédito e com cobrança do ICMS por
                                substituição tributária
                              </option>
                              <option value="24">
                                202-Tributada pelo Simples Nacional sem
                                permissão de crédito e com cobrança do ICMS por
                                substituição tributária
                              </option>
                              <option value="25">
                                203-Isenção do ICMS no Simples Nacional para
                                faixa de receita bruta e com cobrança do ICMS
                                por substituição tributária
                              </option>
                              <option value="26">300-Imune</option>
                              <option value="27">
                                400-Não tributada pelo Simples Nacional
                              </option>
                              <option value="28">
                                500-ICMS cobrado anteriormente por substituição
                                tributária (substituído) ou por antecipação
                              </option>
                              <option value="29">900-Outros</option>
                            </select>
                          </Form.Group>
                        </Col>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formCfop"
                        >
                          <Form.Label
                            style={{ fontSize: '12px', fontWeight: 'bold' }}
                          >
                            CFOP
                          </Form.Label>
                          <Form.Control
                            type="text"
                            required
                            style={{
                              fontSize: '12px',
                              padding: '6px',
                              height: '30px',
                            }}
                            placeholder="CFOP"
                            value={editedItem.cfop}
                            onChange={(e) =>
                              setEditedItem({
                                ...editedItem,
                                cfop: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formUnidade"
                        >
                          <Form.Label
                            style={{ fontSize: '12px', fontWeight: 'bold' }}
                          >
                            Unidade
                          </Form.Label>
                          <Form.Control
                            type="text"
                            required
                            placeholder="Unidade"
                            style={{
                              fontSize: '12px',
                              padding: '6px',
                              height: '30px',
                            }}
                            value={editedItem.unidade}
                            onChange={(e) =>
                              setEditedItem({
                                ...editedItem,
                                unidade: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formBcicms"
                          style={{ textAlign: 'center' }}
                        >
                          <Form.Label
                            style={{ fontSize: '12px', fontWeight: 'bold' }}
                          >
                            BC ICMS
                          </Form.Label>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <Form.Control
                              style={{
                                fontSize: '12px',
                                padding: '6px',
                                height: '30px',
                              }}
                              type="text"
                              placeholder="BC ICMS"
                              value={editedItem.bcicms}
                              onChange={(e) => {
                                setEditedItem({
                                  ...editedItem,
                                  bcicms: e.target.value,
                                })
                              }}
                            />
                            <Button
                              variant="secondary"
                              size="sm"
                              onClick={() => handleBCicms()}
                              title="Aplicar BCICMS"
                            >
                              <span className="bi bi-check2"></span>
                            </Button>
                          </div>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formPorcicms"
                        >
                          <Form.Label
                            style={{ fontSize: '12px', fontWeight: 'bold' }}
                          >
                            Porcentagem ICMS
                          </Form.Label>
                          <Form.Control
                            style={{
                              fontSize: '12px',
                              padding: '6px',
                              height: '30px',
                            }}
                            type="text"
                            placeholder="Porcentagem ICMS"
                            value={editedItem.porcicms}
                            onChange={(e) =>
                              setEditedItem({
                                ...editedItem,
                                porcicms: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formValoricms"
                        >
                          <Form.Label
                            style={{ fontSize: '12px', fontWeight: 'bold' }}
                          >
                            Valor ICMS
                          </Form.Label>
                          <Form.Control
                            style={{
                              fontSize: '12px',
                              padding: '6px',
                              height: '30px',
                            }}
                            type="text"
                            disabled
                            placeholder="Valor ICMS"
                            value={(
                              ((editedItem.bcicms || 0) *
                                (editedItem.porcicms || 0)) /
                              100
                            ).toFixed(2)}
                            onChange={(e) => {
                              const valorcims = e.target.value || 0 // Valor padrão caso o campo seja null ou undefined
                              const porcicms = editedItem.porcicms || 0 // Valor padrão caso porcicms seja null ou undefined
                              setEditedItem({
                                ...editedItem,
                                valoricms: (valorcims * porcicms) / 100,
                              })
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formPorcipi"
                        >
                          <Form.Label
                            style={{ fontSize: '12px', fontWeight: 'bold' }}
                          >
                            % IPI
                          </Form.Label>
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <Form.Control
                              style={{
                                fontSize: '12px',
                                padding: '6px',
                                height: '30px',
                              }}
                              type="text"
                              placeholder="Porcentagem IPI"
                              value={editedItem.porcipi}
                              onChange={(e) =>
                                setEditedItem({
                                  ...editedItem,
                                  porcipi: e.target.value,
                                })
                              }
                            />
                            <Button
                              variant="secondary"
                              size="sm"
                              onClick={() => {
                                const valorIpi = (
                                  (editedItem.bcicms * editedItem.porcipi) /
                                  100
                                ).toFixed(2)
                                setEditedItem({
                                  ...editedItem,
                                  valoripi: valorIpi,
                                })
                              }}
                              title="Calcular IPI"
                            >
                              <span className="bi bi-calculator"></span>
                            </Button>
                          </div>
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formValoripi"
                        >
                          <Form.Label
                            style={{ fontSize: '12px', fontWeight: 'bold' }}
                          >
                            Valor IPI
                          </Form.Label>
                          <Form.Control
                            type="text"
                            style={{
                              fontSize: '12px',
                              padding: '6px',
                              height: '30px',
                            }}
                            placeholder="Valor IPI"
                            value={(
                              ((editedItem.valortotalliquido || 0) *
                                (editedItem.porcipi || 0)) /
                              100
                            ).toFixed(2)}
                            onChange={(e) =>
                              setEditedItem({
                                ...editedItem,
                                valoripi: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formValoricmsst"
                        >
                          <Form.Label
                            style={{ fontSize: '12px', fontWeight: 'bold' }}
                          >
                            Valor ICMS ST
                          </Form.Label>
                          <Form.Control
                            type="text"
                            style={{
                              fontSize: '12px',
                              padding: '6px',
                              height: '30px',
                            }}
                            placeholder="Valor ICMS ST"
                            value={editedItem.valoricmsst}
                            onChange={(e) =>
                              setEditedItem({
                                ...editedItem,
                                valoricmsst: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formPorcicmsest"
                        >
                          <Form.Label
                            style={{ fontSize: '12px', fontWeight: 'bold' }}
                          >
                            BC ICMS ST
                          </Form.Label>
                          <Form.Control
                            type="text"
                            style={{
                              fontSize: '12px',
                              padding: '6px',
                              height: '30px',
                            }}
                            placeholder="BC ICMS ST"
                            value={editedItem.bcicmsst}
                            onChange={(e) =>
                              setEditedItem({
                                ...editedItem,
                                bcicmsst: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formSku"
                        >
                          <Form.Label
                            style={{ fontSize: '12px', fontWeight: 'bold' }}
                          >
                            SKU
                          </Form.Label>
                          <Form.Control
                            type="text"
                            style={{
                              fontSize: '12px',
                              padding: '6px',
                              height: '30px',
                            }}
                            placeholder="SKU"
                            value={editedItem.sku}
                            onChange={(e) =>
                              setEditedItem({
                                ...editedItem,
                                sku: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Fechar
                </Button>

                <Button
                  variant="primary"
                  type="submit"
                >
                  Salvar Alterações
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>

          <Modal
            show={showModalTrans}
            onHide={() => setShowModalTrans(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Tentando transmitir NF-e</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {transmitting ? (
                <div>
                  <FontAwesomeIcon
                    icon={faSpinner}
                    spin
                  />
                  Transmitindo NF-e...
                </div>
              ) : responseMessage === 'NFe Emitida com sucesso' ? (
                <div className="modal-icon">
                  <FontAwesomeIcon
                    icon={faCheck}
                    style={{ color: 'green', marginRight: '5px' }}
                  />
                  {responseMessage}
                </div>
              ) : (
                <div className="modal-icon">
                  <FontAwesomeIcon
                    icon={faTimes}
                    style={{ color: 'red', marginRight: '5px' }}
                  />
                  {responseMessage}
                </div>
              )}
            </Modal.Body>
          </Modal>

          <div
            style={{
              background: '#f8f9fa',
              marginRight: '20px',
              padding: '15px',
              borderTop: '1px solid #dee2e6',
              borderRadius: '0 0 8px 8px',
              display: 'flex',
              gap: '10px',
              flexWrap: 'wrap',
              alignItems: 'center',
            }}
          >
            <CustomButton
              title="Gravar NFe"
              onClick={handleGravarNFe}
              isLoading={isGravarNfeLoading}
              isLoadingText="Gravando..."
            >
              <FloppyDisk
                size={24}
                weight="fill"
              />
            </CustomButton>

            <CustomButton
              title="Consultar Status"
              onClick={() => handleConsultarStatus(idnfe, emp_conta)}
              isLoading={isConsultarLoading}
              isLoadingText="Consultando..."
              color="#2B2D42"
            >
              <Info
                size={24}
                weight="fill"
              />
            </CustomButton>

            <CustomButton
              title="Validar NFe"
              onClick={consultarNfe}
              isEdit
            >
              <ShieldCheck
                size={24}
                weight="fill"
              />
            </CustomButton>

            <CustomButton
              title="Emitir NFe"
              onClick={EmitirNFe}
              isLoading={transmitting}
              isLoadingText="Emitindo..."
              isSuccess
              isDisabled={
                (status === 'R' &&
                  chave &&
                  typeof statusConsultar !== 'string') ||
                status === 'T'
              }
            >
              <Files
                size={24}
                weight="fill"
              />
            </CustomButton>

            <CustomButton
              title="Enviar Dados Fiscais"
              onClick={() => handleDadosFicais(idnfe, emp_conta)}
              isLoading={isEnviarDadosLoading}
              isLoadingText="Enviando..."
              color="#EF233C"
            >
              <UploadSimple
                size={24}
                weight="fill"
              />
            </CustomButton>

            <CustomButton
              title="Imprimir PDF"
              onClick={() => handlePdf(linknfe, idnfe)}
              isDisabled={idnfe <= 0}
            >
              <Printer
                size={24}
                weight="fill"
              />
            </CustomButton>
          </div>
        </div>
      </>
    </ContentLoading>
  )
}

export default EdicaoNFe
